export interface Bonus {
  number: string
  title: string
  description: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Senior Balance & Stability Vault™',
    description:
      'Additional balance drills, stability progressions, and practical session ideas.',
  },
  {
    number: '02',
    title: 'Chair Fitness Collection™',
    description:
      'Ready-to-use seated exercise options for participants who need additional support.',
  },
  {
    number: '03',
    title: 'Express Class Builder™',
    description:
      'Quick planning frameworks for building structured senior sessions when time is limited.',
  },
  {
    number: '04',
    title: 'Mobility & Flexibility Library™',
    description:
      'Practical mobility sequences, movement preparation, and flexibility resources.',
  },
  {
    number: '05',
    title: 'Senior Coach Printable Pack™',
    description:
      'Useful planners, trackers, class sheets, checklists, and coaching resources ready for everyday use.',
  },
]
